export default __webpack_public_path__ + "static/media/GrowingNetwork.13517840.svg";